/**
 * Imagical CMS - Core JS Bundle
 * Standard entrance for all JS logic.
 */

// --- 1. Core & Globals ---
import $ from 'jquery';
window.$ = window.jQuery = $;

// import Swal from 'sweetalert2';
// window.Swal = Swal;

import lodash from 'lodash-es';
window._ = lodash;

import DeviceUUIDWrapper from 'device-uuid';
const DeviceUUIDTemp = (DeviceUUIDWrapper && DeviceUUIDWrapper.DeviceUUID) || (typeof DeviceUUIDWrapper === 'function' ? DeviceUUIDWrapper : null);
if (DeviceUUIDTemp) {
    window.DeviceUUID = DeviceUUIDTemp;
} else if (!window.DeviceUUID && DeviceUUIDWrapper) {
    window.DeviceUUID = DeviceUUIDWrapper;
}


import moment from 'moment';
window.moment = moment;

// --- 2. Dependencies & Libraries ---
import { gsap } from 'gsap';
window.gsap = gsap;

import Inputmask from 'inputmask';
window.Inputmask = Inputmask;
import 'inputmask/dist/jquery.inputmask.js';

import skrollr from 'skrollr';
window.skrollr = skrollr;

import ScrollBooster from 'scrollbooster';
window.ScrollBooster = ScrollBooster;

import Hammer from 'hammerjs';
window.Hammer = Hammer;

import * as FullCalendar from 'fullcalendar';
window.FullCalendar = FullCalendar;

// --- 3. jQuery Plugins (Legacy Support) ---
import './dev/jquery.ui';
import './dev/jquery.datetimepicker';
import './dev/jquery.mjs.nestedSortable';
import './dev/jquery.tablednd';
import './dev/jquery.scrollTo';
import './dev/jquery.slick';
import './dev/jquery.select2';
import './dev/jquery.lcSwitch';
import './dev/jquery.window';
import './dev/jquery.animateNumber';
import './dev/spectrum';
import './dev/jquery.Jcrop';
import './dev/sweetalert';
import './dev/toastr';

// --- 4. File Management ---
import './dev/FileAPI.min';
import './dev/FileAPI.exif';
import './dev/jquery.fileapi';
import './dev/jquery.filedrop';

// --- 5. Imagical CMS - Core Helpers ---
import './imagical/helpers/cms';
import './imagical/helpers/text';
import './imagical/helpers/messages';
import './imagical/helpers/functions';
import './imagical/helpers/ajax';
import './imagical/helpers/cookie';
import './imagical/helpers/browserActions';
import './imagical/helpers/popup';
import './imagical/helpers/slider-swiper';
import './imagical/helpers/slider-slick';
import './imagical/helpers/social';
import './imagical/helpers/math';
import './imagical/helpers/admin';
import './imagical/helpers/tooltips';
import './imagical/helpers/tabs';
import './imagical/helpers/img';
import './imagical/helpers/date';

// --- 6. Imagical CMS - Form System ---
import './imagical/form/input/inc';
import './imagical/form/form';
import './imagical/form/features/functions/progress';
import './imagical/form/features/jquery/range';

// --- 7. Imagical CMS - Icons ---
import './imagical/icons/icons';
import './imagical/icons/iconsView';

// --- 8. Imagical CMS - Components & Engine ---
import './imagical/cmp/dyn';
import './imagical/cmp/svg';
import './imagical/cmp/scrollable';
import './imagical/cms/scroll';
import './imagical/cms/behav';
import './imagical/cms/init';
import './imagical/cms/inputConf';
import './imagical/cms/galerie';

import './bootstrap';

function init() {
    // Final post-load initialization if needed
}

$(init);
